import { FormikHelpers } from "formik";
import AtmModelForm from "./AtmModelForm";
import { useGetAtmModel } from "./api/getAtmModel";
import { useEditAtmModel } from "./api/editAtmModel";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditAtmModel = ({handleCloseModal, atmModelId}: EditAtmModelProps)  => {
  const getAtmModelQuery = useGetAtmModel({atmModelId: atmModelId})
  const editAtmModelMutation = useEditAtmModel({data: {}, atmModelId});

  const handleSubmit = async (values: IPostEditAtmModel, { setSubmitting }: FormikHelpers<IPostEditAtmModel>): Promise<void> => {
    try {
      await editAtmModelMutation.mutateAsync({
        data: values,
        atmModelId: atmModelId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getAtmModelQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAtmModelQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Μοντέλου.</div>
    )
  }

  return (
    <>
      {!getAtmModelQuery.isLoading && getAtmModelQuery.data &&
        <AtmModelForm initialValues={getAtmModelQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditAtmModelProps {
  atmModelId: number;
  handleCloseModal: () => void;
}

export default EditAtmModel;